import { createEntityAdapter, createSlice, EntityState, PayloadAction } from '@reduxjs/toolkit'
import { AiFeaturePreset } from '../../models/AiFeaturePreset'
import { RootState } from '../store'

interface AiFeaturePresetsState {
  isLoading: boolean
  aiFeaturePresets: EntityState<AiFeaturePreset, string>
}

const aiFeaturePresetsAdapter = createEntityAdapter<AiFeaturePreset>()

const initialState: AiFeaturePresetsState = {
  isLoading: true,
  aiFeaturePresets: aiFeaturePresetsAdapter.getInitialState(),
}

export const aiFeaturePresetsSlice = createSlice({
  name: 'aiFeaturePresets',
  initialState,
  reducers: {
    setAiFeaturePresetsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setAiFeaturePresets: (state, action: PayloadAction<AiFeaturePreset[]>) => {
      aiFeaturePresetsAdapter.setAll(state.aiFeaturePresets, action.payload)
    },
    resetAiFeaturePresets: () => initialState,
  },
})

export const { setAiFeaturePresetsLoading, setAiFeaturePresets, resetAiFeaturePresets } = aiFeaturePresetsSlice.actions

const aiFeaturePresetsSelectors = aiFeaturePresetsAdapter.getSelectors((state: RootState) => state.meetingSummary.aiFeaturePresets.aiFeaturePresets)

export const selectAiFeaturePresets = (state: RootState) => aiFeaturePresetsSelectors.selectAll(state)
